export const config = {
  pagination: false,
  rowSelection: false,
  columns: [
    {
      title: 'SKU名称',
      dataIndex: 'skuName',
      width: 250,
      render: 'nameRender'
    },
    {
      title: 'SKU_ID',
      dataIndex: 'id',
      width: 200,
      ellipsis: true,
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 120,
      ellipsis: true,
    },
    {
      title: 'SKU适用门店',
      dataIndex: 'shops',
      width: 200,
      ellipsis: true,
      render: 'shopNameRender',
    },
    {
      title: 'SKU状态',
      dataIndex: 'enabled',
      width: 120,
      render: 'enabledRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'skuNameKeyword',
      label: 'SKU名称/ID',
    },
  ],
}